import React from 'react';
import propTypes from 'prop-types';
import TSTable from '../common/TSTable';
import { useTranslation } from 'react-i18next';
import { Media } from "../../AppMedia";
import MobileList from '../common/MobileList';
import { Modal, Space, } from 'antd';
import { HistoryOutlined, CalendarFilled, InfoCircleFilled, UserOutlined, EditFilled } from '@ant-design/icons';

function HistoryListModal(props) {

  const {
    open,
    onClose,
    workflowHistoryUrl,
  } = props;

  const { t } = useTranslation();

  const columns = React.useMemo(() => [
    {
      title: t('time'),
      dataIndex: 'timestamp',
      render: (__, original) => new Date(original.timestamp).toLocaleString('en-GB'),
    },
    {
      title: t('user'),
      dataIndex: 'by',
    },
    {
      title: t('workflows.action'),
      dataIndex: 'transition',
      render: (value) => t(`workflows.actions.${value}`)
    },
    {
      title: t('memo'),
      dataIndex: 'description',
      render: (__, original) => original.description ? original.description : '-'
    },
  ], []);

  const content = {
    descriptions: [
      {
        icon: <CalendarFilled />,
        header: (item) => t('time'),
        detail: (item) => new Date(item.timestamp).toLocaleString('en-GB')
      },
      {
        icon: <UserOutlined />,
        header: (item) => t('user'),
        detail: (item) => item.by
      },
      {
        icon: <EditFilled />,
        header: (item) => t('workflows.action'),
        detail: (item) => t(`workflows.actions.${item.transition}`)
      },
      {
        icon: <InfoCircleFilled />,
        header: (item) => t('memo'),
        detail: (item) => item.description ? item.description : '-'
      }
    ],
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <Space>
          <HistoryOutlined />
          {t('workflows.history')}
        </Space>
      }
      footer={null}
    >
      <Media greaterThan={"sm"}>
        <TSTable
          url={workflowHistoryUrl}
          columns={columns}
          showPagination
        />
      </Media>

      <Media at={"sm"}>
        <MobileList
          fetchUrl={workflowHistoryUrl}
          content={content}
        />
      </Media>

    </Modal >
  );
}

export default React.memo(HistoryListModal);

HistoryListModal.defaultProps = {
  open: false,
  onClose: () => null,
  workflowHistoryUrl: '',
}

HistoryListModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  workflowHistoryUrl: propTypes.string,
}

